import { IPackage } from '../types';

export function unselectAllPackages(packagesList: IPackage[]): IPackage[] {
  return packagesList.map(item => {
    return { ...item, selected: false };
  });
}
